import React, { useState } from "react";
import clientReviews from "../../assets/data/people-say.json";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Testimonials = () => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = (index) => {
    setIsReadMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  return (
    <section className="testimonial-sec">
      <div className="container">
        <div className="section-heading  review-section-heading   flex-row justify-content-between">
          <h2>What our client's say</h2>
          <div className="view-all-review">
            <Link
              to="https://www.google.com/search?sca_esv=bfc79b9b44160e7b&sxsrf=ANbL-n7w72x3-IEFHsK80vZZz3ssYBvGYg:1768215995149&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOfAABQrCebcv44iwDj0XX4liHqiO4Qdbw1U-m59Ne0khV_X4SR5doiWlwA8FN1smt7tYkvLejKfIkPcfNh3UhCC99Tth&q=sowerent.com+Reviews&sa=X&ved=2ahUKEwihq5vy7YWSAxV5SmwGHQ9IE5cQ0bkNegQIKxAE&biw=1536&bih=730&dpr=1.25&aic=0"
              className=" btn btn-primary d-inline-block rounded "
              target="_blank"
            >
              View All Reviews{" "}
              <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Swiper
              className="testimonial-slider"
              slidesPerView={1}
              spaceBetween={24}
              navigation={true}
              modules={[Navigation]}
              breakpoints={{
                576: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                991: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 24,
                },
              }}
            >
              {clientReviews.peopleSay.map((clientReview, index) => {
                const textWords = clientReview.review.split(" ");
                const isExpanded = isReadMore[index];
                const displayedText = isExpanded
                  ? clientReview.review
                  : textWords.slice(0, 30).join(" ");
                return (
                  <SwiperSlide key={`client-review-${index}`}>
                    <div
                      className="testimonial-card aos"
                      data-aos="fade-down"
                      data-aos-duration={2000}
                    >
                      <p>
                        {displayedText}
                        {textWords.length > 30 && (
                          <span>
                            {isExpanded ? "" : "..."}
                            <button
                              className="read-more"
                              onClick={() => toggleReadMore(index)}
                            >
                              {isExpanded ? "Read Less" : "Read More"}
                            </button>
                          </span>
                        )}
                      </p>
                      <div className="content-wrap">
                        <p className="testimonial-heading">
                          <Link to="">{clientReview.name}</Link>
                        </p>
                        <div className="rating">
                          {Array.from({ length: clientReview.rating }).map(
                            (_, keyindex) => (
                              <span key={keyindex}>
                                <FontAwesomeIcon icon={faStar} />
                              </span>
                            ),
                          )}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
